import React from "react";
import { StyleSheet, View, Image } from "react-native";

//Custom Import
import { scale } from "@utils/scale";
import color from "@constants/color";
import t from "@constants/localization";
import CustomText from "@components/CustomText";

const PATH = "screens/Contest";

const ContestEmptyComponent = () => {
  return (
    <View style={styles.container}>
      <Image
        resizeMode={"contain"}
        style={styles.imageContainer}
        source={require("../../../assets/images/nocontest.png")}
      />
      <CustomText
        variant="body_text_1"
        newfont={true}
        style={styles.noContestText}
      >
        {t(`${PATH}/noContest`)}
      </CustomText>
    </View>
  );
};

const PastEmptyComponent = () => {
  return (
    <View style={styles.container}>
      <Image
        resizeMode={"contain"}
        style={styles.imageContainer}
        source={require("../../../assets/images/past_contest.png")}
      />
      <CustomText
        variant="body_text_1"
        newfont={true}
        style={styles.noContestText}
      >
        {t(`${PATH}/noPastContest`)}
      </CustomText>
    </View>
  );
};

const OrderedEmptyComponent = () => {
  return (
    <View style={styles.container}>
      <Image
        resizeMode={"contain"}
        style={styles.imageContainer}
        source={require("../../../assets/images/past_contest.png")}
      />
      <CustomText
        variant="body_text_1"
        newfont={true}
        style={styles.noContestText}
      >
        {t(`${PATH}/orderedEmptyList`)}
      </CustomText>
    </View>
  );
};

const ConestSectionSeparator = ({ leadingSection, trailingItem }) => {
  if (leadingSection === undefined && trailingItem === undefined) {
    return (
      <View style={styles.separator}>
        <View style={styles.silverLine} />
      </View>
    );
  } else return null;
};

export {
  ContestEmptyComponent,
  PastEmptyComponent,
  OrderedEmptyComponent,
  ConestSectionSeparator,
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  imageContainer: {
    width: scale(267),
    height: 178,
  },
  noContestText: {
    color: color.mediumBlack,
    marginTop: 10,
  },
  separator: {
    height: 8,
  },
  silverLine: {
    position: "absolute",
    height: 8,
    zIndex: 100,
    backgroundColor: color.shadowLighter,
    right: -16,
    left: -16,
    alignSelf: "center",
  },
});
